// modded
//
// Purpose: Modded and BulbBox preset categories
//
// This module:
// - Exports preset categories: BulbBox, Misc Modded, UnBox Synth Lead

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const moddedCategories: InputPresetCategory[] = [
	{
		name: "BulbBox Presets",
		presets: toNameMap([
			// Drum Presets
			{
				name: "BulbBox C1 Square Kick",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "kick"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["panning", "pitch shift"],
					pitchShiftSemitones: 24,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 0.75,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox C2 Snare Kick (Part 1)",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "kick", "snare"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "pitch shift"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 0.3,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox D3 Snare Noise (Part 2)",
				midiProgram: 80,
				tags: ["noise", "bulbbox", "snare"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "transition type", "pitch shift"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 19,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "white",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 0.4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox A4 Hi-Hat",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "hihat"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 2.8284 }],
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "ALL",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.5,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox FM Kick",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "kick"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "pitch shift", "note filter"],
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←3←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "8×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "pitchShift",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorFrequency",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.6,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							index: 3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox A2 Snare",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "snare", "featured"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.5 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
					],
					eqSubFilters1: [],
					effects: ["panning", "detune", "note filter", "distortion"],
					detuneCents: -44,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 2000, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 176.78, linearGain: 5.6569 },
					],
					distortion: 71,
					aliases: false,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4",
					feedbackType: "4⟲",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Wyatt Kick",
				generalMidi: false,
				tags: ["fm", "fm6op", "bulbbox", "kick"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 2 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 2 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 25,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 250, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 2 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 2 },
						{ type: "peak", cutoffHz: 13454.34, linearGain: 2 },
					],
					eqSubFilters1: [],
					effects: ["distortion"],
					distortion: 29,
					aliases: false,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "10×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 15,
							waveform: "broken white noise",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "3.5×",
							amplitude: 12,
							waveform: "broken white noise",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 40,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							index: 1,
						},
					],
				},
			},
			{
				name: "BulbBox Wyatt Snare",
				generalMidi: false,
				tags: ["fm", "fm6op", "bulbbox", "snare"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 21,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 11313.71, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 250, linearGain: 2 },
					],
					eqSubFilters1: [],
					effects: ["distortion", "echo"],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					echoSustain: 0,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←4 2←5 3←6",
					feedbackType: "2⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "11×", amplitude: 15, waveform: "trapezoid", pulseWidth: 5 },
						{
							frequency: "0.12×",
							amplitude: 13,
							waveform: "broken white noise",
							pulseWidth: 5,
						},
						{
							frequency: "3.5×",
							amplitude: 10,
							waveform: "broken white noise",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "~1×",
							amplitude: 9,
							waveform: "broken white noise",
							pulseWidth: 5,
						},
						{
							frequency: "~1×",
							amplitude: 15,
							waveform: "broken white noise",
							pulseWidth: 5,
						},
					],
					envelopes: [
						{
							target: "operatorFrequency",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.4,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "fall",
							inverse: true,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 14,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
					],
				},
			},
			// Bass Presets
			{
				name: "BulbBox Shocker Bass",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "10×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "Sawtooth Bass",
				midiProgram: 80,
				tags: ["chip", "chipwave", "bulbbox", "bass"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 0.7071,
						},
					],
					effects: ["panning", "distortion", "bitcrusher", "reverb", "phaser"],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					phaserMix: 81,
					phaserFreq: 0,
					phaserFeedback: 26,
					phaserStages: 6,
					pan: 0,
					panDelay: 10,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					unison: "recurve",
					wave: "sawtooth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 2,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox C64 Bass",
				midiProgram: 80,
				tags: ["pwm", "bulbbox", "bass"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "note filter"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 5.6569 }],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					pulseWidth: 50,
					decimalOffset: 0,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: true,
							perEnvelopeSpeed: 15,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox SuperSaw Bass",
				midiProgram: 80,
				tags: ["supersaw", "bulbbox", "bass"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					effects: ["panning", "note filter", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					pan: 0,
					panDelay: 0,
					echoSustain: 57,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Evil Bass",
				midiProgram: 80,
				tags: ["pickedstring", "bulbbox", "bass"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 86, 86, 86, 86, 86, 86, 100, 100, 100, 86, 71, 71, 57, 57,
						57, 43, 43, 43, 43, 29, 29, 29, 29, 14, 100,
					],
					unison: "inject",
					stringSustain: 7,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Pulse Bass",
				midiProgram: 80,
				tags: ["pwm", "bulbbox", "bass"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.125 }],
					effects: ["panning", "transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 353.55, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1,
						},
					],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "octave",
					pulseWidth: 50,
					decimalOffset: 0,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.2,
							waveform: 0,
						},
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 10,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 2,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			// Lead Presets
			{
				name: "BulbBox Synth Slap Bass",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "bass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.125 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "note filter", "distortion", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 88.39,
							linearGain: 8,
						},
					],
					distortion: 57,
					aliases: false,
					pan: 0,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Saw Lead",
				midiProgram: 80,
				tags: ["chip", "chipwave", "bulbbox", "lead"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["panning", "detune", "distortion", "echo", "reverb"],
					detuneCents: -10,
					distortion: 71,
					aliases: false,
					pan: 0,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "octave",
					wave: "sawtooth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Spooky Triangle",
				midiProgram: 80,
				tags: ["chip", "chipwave", "bulbbox"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "vibrato", "note filter", "echo", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.52,
					vibratoDelay: 10,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 4,
						},
					],
					pan: 0,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "triangle",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
					isDrum: false,
				},
			},
			// Guitar Presets
			{
				name: "BulbBox Distortion Guitar 1",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "distortion"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "vibrato", "note filter", "distortion", "bitcrusher"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 6727.17,
							linearGain: 2,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 3,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Distortion Guitar 2",
				midiProgram: 80,
				tags: ["pickedstring", "bulbbox", "distortion"],
				settings: {
					type: "Picked String",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
						"phaser",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 5.6569 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 4 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 5.6569 },
					],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 100,
					phaserMix: 39,
					phaserFreq: 0,
					phaserFeedback: 0,
					phaserStages: 6,
					pan: 0,
					panDelay: 10,
					chorus: 43,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 57, 57, 57, 57, 57, 71, 71, 71,
						57, 57, 43, 43, 29, 29, 29, 43, 100, 100, 86,
					],
					unison: "none",
					stringSustain: 50,
					envelopes: [
						{
							target: "stringSustain",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1.1,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			// Key Presets
			{
				name: "BulbBox Electric Piano",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "keys"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "vibrato"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.3,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 2,
						},
						{
							target: "operatorAmplitude",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.2,
							index: 0,
							steps: 2,
							seed: 55,
							waveform: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Synth Piano",
				midiProgram: 80,
				tags: ["pwm", "bulbbox", "keys"],
				settings: {
					type: "PWM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.0884 }],
					effects: ["panning", "detune", "vibrato", "note filter", "reverb"],
					detuneCents: -10,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 9,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 125, linearGain: 0.0884 }],
					pan: 0,
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "honky tonk",
					pulseWidth: 70,
					decimalOffset: 0,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Synth Keys",
				midiProgram: 80,
				tags: ["supersaw", "bulbbox", "keys"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 5.6569,
						},
					],
					effects: ["panning", "vibrato", "bitcrusher"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 80,
					decimalOffset: 0,
					dynamism: 100,
					spread: 67,
					shape: 17,
					envelopes: [
						{
							target: "pulseWidth",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.7,
							perEnvelopeUpperBound: 1.3,
							waveform: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox OPLL Piano",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "keys"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 8, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.2,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 0.3,
							index: 0,
						},
					],
					isDrum: false,
				},
			},
			// Brass And Woodwind Presets
			{
				name: "BulbBox Trumpet",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "brass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.1,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.1,
							index: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Brass",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "brass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.8,
							perEnvelopeUpperBound: 1.1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Synth Sax",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "brass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 88.39, linearGain: 0.0884 }],
					eqSubFilters1: [],
					effects: ["panning", "distortion", "bitcrusher"],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 0,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.5,
							index: 0,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0.4,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "BulbBox Flute",
				midiProgram: 80,
				tags: ["fm", "fm4op", "bulbbox", "flute"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning", "vibrato"],
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 5,
					vibratoSpeed: 5,
					vibratoType: 0,
					pan: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 3, waveform: "half-sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							index: 1,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
		]),
	},
	{
		name: "Misc Modded Presets",
		presets: toNameMap([
			// -------------JukeBox 0.0.1--------------
			{
				name: "modbox theepsynth",
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					effects: "none",
					transition: "hard",
					chord: "arpeggio",
					filterCutoffHz: 4000,
					filterResonance: 14,
					filterEnvelope: "custom",
					vibrato: "none",
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 11,
					feedbackEnvelope: "steady",
					operators: [
						{ frequency: "1×", amplitude: 15, envelope: "custom" },
						{ frequency: "1×", amplitude: 15, envelope: "custom" },
						{ frequency: "2×", amplitude: 7, envelope: "steady" },
						{ frequency: "1×", amplitude: 11, envelope: "steady" },
					],
				},
			},

			{
				name: "blackbox deep key",
				midiProgram: 9,
				generalMidi: true,
				tags: ["harmonics", "keys"],
				settings: {
					type: "harmonics",
					effects: "reverb",
					transition: "hard fade",
					chord: "harmony",
					filterCutoffHz: 8000,
					filterResonance: 32,
					filterEnvelope: "twang 1",
					interval: "shimmer",
					vibrato: "light",
					harmonics: [
						100, 86, 86, 86, 86, 71, 71, 57, 0, 57, 29, 43, 57, 57, 57, 43, 43, 0, 29,
						43, 43, 43, 43, 43, 43, 29, 0, 30,
					],
				},
			},
			{
				name: "blackbox ring ding",
				midiProgram: 78,
				generalMidi: true,
				tags: ["fm", "fm4op"],
				settings: {
					type: "FM",
					effects: "reverb",
					transition: "hard",
					chord: "strum",
					filterCutoffHz: 1500,
					filterResonance: 16,
					filterEnvelope: "twang 2",
					vibrato: "none",
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					feedbackEnvelope: "steady",
					operators: [
						{ frequency: "1×", amplitude: 9, envelope: "custom" },
						{ frequency: "4×", amplitude: 8, envelope: "custom" },
						{ frequency: "12×", amplitude: 9, envelope: "custom" },
						{ frequency: "22×", amplitude: 4, envelope: "twang 2" },
					],
				},
			},

			{
				name: "todbox accordion",
				midiProgram: 21,
				generalMidi: true,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					effects: "reverb",
					transition: "cross fade",
					chord: "harmony",
					filterCutoffHz: 5657,
					filterResonance: 0,
					filterEnvelope: "swell 1",
					wave: "todbox accordian",
					interval: "honky tonk",
					vibrato: "none",
				},
			},
			{
				name: "todbox wind",
				generalMidi: false,
				tags: ["fm", "fm4op", "ambience"],
				settings: {
					type: "FM",
					effects: "reverb",
					transition: "seamless",
					chord: "harmony",
					filterCutoffHz: 200,
					filterResonance: 2950,
					filterEnvelope: "steady",
					vibrato: "none",
					algorithm: "1→3 2→4",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 15,
					feedbackEnvelope: "steady",
					operators: [
						{ frequency: "16×", amplitude: 15, envelope: "steady" },
						{ frequency: "16×", amplitude: 0, envelope: "custom" },
						{ frequency: "16×", amplitude: 15, envelope: "steady" },
						{ frequency: "16×", amplitude: 0, envelope: "flare 2" },
					],
				},
			},
			// AEVOK Whistle
			{
				name: "Whastle (VoxBox)",
				generalMidi: false,
				tags: ["harmonics", "featured"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					detuneCents: 24,
					vibrato: "custom",
					vibratoDepth: 0.24,
					vibratoDelay: 19,
					vibratoSpeed: 4,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					pan: 0,
					panDelay: 10,
					chorus: 100,
					reverb: 32,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					harmonics: [
						100, 86, 71, 43, 57, 43, 43, 43, 43, 43, 43, 43, 43, 29, 29, 29, 29, 29, 29,
						29, 14, 14, 14, 14, 14, 14, 14, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 2" }],
					isDrum: false,
				},
			},
			// AEVOK Guitar
			{
				name: "Nastortion Guitar (VoxBox)",
				generalMidi: false,
				tags: ["harmonics", "featured", "distortion", "guitar"],
				settings: {
					type: "harmonics",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"panning",
						"pitch shift",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 12,
					detuneCents: 22,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 }],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 100,
					pan: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 35,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					harmonics: [
						100, 14, 57, 14, 29, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 2" },
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
						},
					],
					isDrum: false,
				},
			},
			// 11 AM Bass
			{
				name: "Sawcoustic Bass (VoxBox)",
				generalMidi: false,
				tags: ["fm", "fm4op", "bass"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 17,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 1.4142,
						},
					],
					effects: ["panning", "transition type", "detune", "note filter"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 13,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 }],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopeInverse0: false,
					envelopeInverse1: false,
					envelopeInverse2: false,
					envelopeInverse3: false,
					envelopeInverse4: false,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "twang 2",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 2",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang -1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							index: 2,
						},
						{
							target: "operatorFrequency",
							envelope: "linear-1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							index: 3,
						},
					],
					isDrum: false,
				},
			},
			// BloxBox
			{
				name: "Chip Guitar (BloxBox)",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.0884 }],
					effects: ["vibrato", "reverb"],
					vibrato: "delayed",
					reverb: 67,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "ModBox Guitar",
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "twang 2" }],
				},
			},
			{
				name: "Bass Triangle Wave (BloxBox)",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro", "bass"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 105.11,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.3536 },
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			// BonBox
			{
				name: "Bon Wave (BonBox)",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					effects: ["transition type", "vibrato"],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "square",
					unison: "dissonant",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Silly Wave (BonBox)",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 }],
					effects: ["vibrato"],
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					wave: "sawtooth",
					unison: "recurve",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			// DinoBox
			{
				name: "harmonics test (DinoBox)",
				generalMidi: false,
				tags: ["harmonics"],
				settings: {
					type: "harmonics",
					volume: 80,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.5,
						},
					],
					preset: 1088,
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.5 }],
					reverb: 67,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -6,
					harmonics: [
						100, 100, 57, 14, 57, 43, 14, 29, 29, 43, 29, 43, 57, 14, 0, 14, 14, 0, 0,
						14, 14, 14, 14, 14, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "decay 3" }],
				},
			},
			{
				name: "musical trollge (DinoBox)",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					volume: 80,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.1768 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 8 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 5.6569 },
					],
					preset: 1089,
					effects: ["transition type", "note filter", "reverb"],
					transition: "slide",
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 }],
					reverb: 33,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2 3 4",
					feedbackType: "1→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 14 },
						{ frequency: "~2×", amplitude: 15 },
						{
							frequency: "1×",
							amplitude: 14,
						},
						{ frequency: "11×", amplitude: 15 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 1" }],
				},
			},
			// D's Quick Box Mod
			{
				name: "D's 1/8 Pulse (D's Quick Box Mod)",
				generalMidi: false,
				tags: ["chip", "chipwave", "retro"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["transition type", "vibrato"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.6,
					vibratoDelay: 27.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1/8 pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 8,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			// custom presets from [axobox]
			{
				name: "dusty chip (axobox)",
				generalMidi: false,
				isNoise: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["detune", "note filter", "bitcrusher", "chorus"],
					detuneCents: -45,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					chorus: 71,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 72,
					wave: "sawtooth",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "flare 3" }],
				},
			},
			{
				name: "bouncy ball (axobox)",
				generalMidi: false,
				isNoise: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["detune", "echo", "reverb"],
					detuneCents: -45,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "rounded",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "lifetime wave (axobox)",
				generalMidi: false,
				isNoise: false,
				tags: ["chip", "chipwave", "featured"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					effects: ["transition type", "detune", "vibrato", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -45,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					echoSustain: 86,
					echoDelayBeats: 1,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "fifth",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "star (axobox)",
				generalMidi: false,
				isNoise: false,
				tags: ["chip", "chipwave"],
				settings: {
					type: "chip",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["detune", "note filter", "chorus", "echo", "reverb"],
					detuneCents: -45,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					chorus: 100,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "rounded",
					unison: "octave",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			// these are awesome

			// -------------JukeBox 0.3.0--------------
			{
				name: "Rhodes Part A (VoxBox)",
				generalMidi: false,
				tags: ["fm", "fm4op", "keys"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 16000,
							linearGain: 0.1768,
						},
					],
					eqSubFilters1: [],
					effects: ["transition type", "detune", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: 2,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "3×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "7×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopeInverse0: false,
					envelopeInverse1: false,
					envelopeInverse2: false,
					envelopeInverse3: false,
					envelopes: [
						{
							target: "feedbackAmplitude",
							envelope: "twang 1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang 1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							index: 3,
						},
						{
							target: "noteVolume",
							envelope: "punch",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang 1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							index: 2,
						},
					],
				},
			},
			{
				name: "Rhodes Part B (VoxBox)",
				generalMidi: false,
				tags: ["pickedstring", "keys"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: -2,
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 86, 14, 14, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 93,
					envelopeInverse0: false,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "punch",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			{
				name: "Rhodes Part C (VoxBox)",
				generalMidi: false,
				tags: ["spectrum", "keys"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 24,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 4756.83,
							linearGain: 1,
						},
					],
					effects: ["transition type", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 86, 71, 71, 71, 71,
						71, 71, 71, 57, 57, 43, 43, 29, 29, 29, 14, 14, 0, 0,
					],
					unison: "none",
					envelopeInverse0: false,
					envelopeInverse1: false,
					envelopeInverse2: false,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay 1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "twang 1",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
						{
							target: "noteVolume",
							envelope: "blip 2",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
						},
					],
				},
			},
			// { name: "", generalMidi: false, tags:[""], settings: {} },
		]),
	},
	{
		name: "Misc Modded Novelty Presets",
		presets: toNameMap([
			// Made by Slarmoo
			{
				name: "bitcrushed artifacts (Slarmoo's Box)",
				generalMidi: false,
				tags: ["pickedstring", "slarmoo'sbox", "novelty", "ambience"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["distortion", "bitcrusher", "echo"],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 2,
					bitcrusherQuantization: 86,
					echoSustain: 0,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -6,
					harmonics: [
						0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 100, 43, 0, 0, 14, 86, 0, 14, 0,
						0, 0, 0, 0, 86,
					],
					unison: "none",
					stringSustain: 14,
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "whistle 2 (Slarmoo's Box)",
				midiProgram: 78,
				tags: ["harmonics", "slarmoo'sbox", "novelty", "flute"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 2110.37, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 3,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 11,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 88.39,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
					],
					distortion: 43,
					aliases: false,
					echoSustain: 57,
					echoDelayBeats: 1.083,
					reverb: 87,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -1,
					harmonics: [
						57, 0, 0, 0, 0, 0, 0, 0, 0, 86, 57, 0, 0, 0, 0, 0, 0, 0, 86, 0, 0, 0, 57,
						29, 0, 29, 100, 0,
					],
					unison: "none",
					envelopes: [{ target: "pitchShift", envelope: "decay 1" }],
					isDrum: false,
				},
			},
			{
				name: "frog wuh 𓆏 (Slarmoo's Box)",
				generalMidi: false,
				tags: ["spectrum", "slarmoo'sbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 8,
						},
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 8,
						},
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.125 },
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter"],
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1000, linearGain: 1 }],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					spectrum: [
						100, 29, 14, 29, 0, 14, 0, 71, 0, 43, 14, 71, 0, 0, 71, 14, 100, 0, 71, 0,
						43, 86, 43, 0, 43, 0, 0, 43, 29, 29,
					],
					envelopes: [
						{ target: "pitchShift", envelope: "twang 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 1",
						},
					],
					isDrum: false,
				},
			},
			{
				name: "stationary harmonics (Slarmoo's Box)",
				generalMidi: false,
				tags: ["harmonics", "slarmoo'sbox", "novelty", "pad"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 1,
						},
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.5 },
					],
					effects: ["transition type", "chord type", "vibrato"],
					transition: "continue",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 0, 57, 29, 14, 57, 29, 29, 14, 14, 29, 43, 14, 14, 14, 0, 14, 29, 29,
						14, 0, 0, 14, 0, 0, 29, 14, 14,
					],
					unison: "stationary",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "dead souls (Slarmoo's Box)",
				generalMidi: false,
				tags: ["spectrum", "slarmoo'sbox", "novelty", "sfx"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: true,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.0884,
						},
						{ type: "peak", cutoffHz: 707.11, linearGain: 1.4142 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"distortion",
						"chorus",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: -200,
					distortion: 100,
					aliases: false,
					chorus: 14,
					reverb: 35,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 71, 43, 43, 29, 29, 29, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 57, 14, 14, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "random",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 24,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.2,
							steps: 16,
							seed: 37,
							waveform: 0,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
						{
							target: "detune",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: true,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
						{
							target: "distortion",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							steps: 2,
							seed: 2,
							waveform: 0,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "flutter (Slarmoo's Box)",
				generalMidi: false,
				tags: ["fm", "fm4op", "slarmoo'sbox", "novelty", "sfx"],
				settings: {
					type: "FM",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 6727.17,
							linearGain: 2.8284,
						},
					],
					effects: ["transition type", "chorus", "reverb", "ring mod"],
					transition: "interrupt",
					clicklessTransition: false,
					ringMod: 100,
					ringModHz: 100,
					ringModWaveformIndex: 0,
					panDelay: 0,
					chorus: 14,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "ringModulationHz",
							envelope: "fall",
							inverse: false,
							perEnvelopeSpeed: 1.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1.9,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 0.25,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "vinyl (Slarmoo's Box)",
				generalMidi: false,
				tags: ["noise", "slarmoo'sbox", "novelty", "sfx"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 1189.21,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 1414.21, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 1189.21,
							linearGain: 0.25,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 1,
						},
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					chorus: 29,
					echoSustain: 14,
					echoDelayBeats: 0.083,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "crackling",
					unison: "none",
					envelopes: [],
					isDrum: false,
				},
			},
			{
				name: "liminal (Slarmoo's Box)",
				generalMidi: false,
				isNoise: false,
				tags: ["supersaw", "slarmoo'sbox", "novelty", "arp"],
				settings: {
					type: "supersaw",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 0.25,
						},
					],
					effects: [
						"detune",
						"vibrato",
						"note filter",
						"granular",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					detuneCents: 8,
					vibrato: "custom",
					vibratoDepth: 0.48,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 2196.8, linearGain: 1 }],
					granular: 6,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					chorus: 29,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					pulseWidth: 30,
					decimalOffset: 0,
					dynamism: 17,
					spread: 83,
					shape: 67,
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 17,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "pulseWidth",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 1.3333,
							perEnvelopeLowerBound: 0.1,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "distortion",
							envelope: "random",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.2,
							perEnvelopeUpperBound: 1,
							discrete: true,
							steps: 8,
							seed: 2,
							waveform: 2,
						},
						{
							target: "panning",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 0.3333,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 2,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 18,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "granular",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
					isDrum: false,
				},
			},
			{
				name: "sandbox pink ping",
				generalMidi: false,
				midiSubharmonicOctaves: -1,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					effects: "reverb",
					transition: "soft",
					chord: "harmony",
					filterCutoffHz: 3000,
					filterResonance: 0,
					filterEnvelope: "tripolo6",
					spectrum: [
						0, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
				},
			},
			{
				name: "Depths (MidBox)",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 62.5, linearGain: 2 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 0,
					detuneCents: -52,
					vibrato: "custom",
					vibratoDepth: 0.56,
					vibratoDelay: 0,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.0884 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 100,
					reverb: 71,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterFreq", envelope: "tremolo4", index: 0 }],
				},
			},
			{
				name: "Odd Snare (MidBox)",
				generalMidi: false,
				tags: ["fm", "fm4op", "midbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					pitchShiftSemitones: 24,
					detuneCents: 200,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 176.78,
							linearGain: 2.8284,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 176.78,
							linearGain: 2.8284,
						},
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.083,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "(1 2)←3←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "16×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang 3", index: 0 },
						{ target: "noteFilterFreq", envelope: "twang 1", index: 0 },
						{ target: "pitchShift", envelope: "twang 3" },
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{ target: "noteFilterFreq", envelope: "swell 1", index: 1 },
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
						{ target: "operatorFrequency", envelope: "twang 1", index: 0 },
					],
				},
			},
			{
				name: "Mechanical Blip (MidBox)",
				generalMidi: false,
				tags: ["chip", "chipwave", "midbox", "novelty", "featured"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.3536 },
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.3536 },
					],
					effects: [
						"transition type",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 500, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 500, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 11.3137,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 43,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "rounded",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "shit (ShitBox)",
				midiProgram: 80,
				tags: ["chip", "chipwave", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide in pattern",
					chord: "arpeggio",
					pitchShiftSemitones: 24,
					detuneCents: 45,
					vibrato: "heavy",
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 148.65, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 16000, linearGain: 11.3137 },
					],
					distortion: 100,
					bitcrusherOctave: 0,
					bitcrusherQuantization: 100,
					chorus: 100,
					echoSustain: 100,
					echoDelayBeats: 2,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "spiky",
					unison: "piano",
					envelopes: [],
				},
			},
			{
				name: "odd yet musical (DinoBox)",
				generalMidi: false,
				tags: ["fm", "fm4op", "novelty"],
				settings: {
					type: "FM",
					volume: 80,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1414.21, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.7071,
						},
					],
					preset: 1090,
					effects: ["note filter", "bit crusher", "reverb"],
					noteFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 5.6569 }],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 71,
					reverb: 33,
					fadeInSeconds: 0.075,
					fadeOutTicks: 12,
					algorithm: "1←(2 3←4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 11 },
						{ frequency: "3×", amplitude: 0 },
						{
							frequency: "5×",
							amplitude: 7,
						},
						{ frequency: "5×", amplitude: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "flare 2" }],
				},
			},
			{
				name: "void (axobox)",
				generalMidi: false,
				isNoise: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.5 }],
					reverb: 32,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 72,
					spectrum: [
						100, 43, 29, 29, 14, 14, 14, 14, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},

			{
				name: "scifi-uoh (Studio Box)",
				generalMidi: false,
				tags: ["harmonics", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "peak", cutoffHz: 594.6, linearGain: 4 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.0884 },
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["pitch shift", "note filter", "chorus", "echo", "reverb"],
					pitchShiftSemitones: 7,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 5,
					noteFilter: [{ type: "low-pass", cutoffHz: 7980.25, linearGain: 4 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 4 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 7980.25, linearGain: 4 }],
					panDelay: 0,
					chorus: 100,
					echoSustain: 71,
					echoDelayBeats: 1.167,
					reverb: 77,
					reverbfeedback: 77,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						0, 0, 0, 86, 29, 86, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [
						{
							target: "pitchShift",
							envelope: "linear",
							inverse: true,
							perEnvelopeSpeed: 19,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "wind spectrum (Studio Box)",
				generalMidi: false,
				tags: ["spectrum", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 9,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["granular", "bitcrusher", "echo", "reverb"],
					granular: 4,
					grainSize: 49,
					grainAmounts: 10,
					grainRange: 40,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					echoSustain: 86,
					echoDelayBeats: 0.5,
					reverb: 6,
					reverbfeedback: 77,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 100, 100, 100, 100, 100, 100, 0, 0, 100, 100, 100, 100, 100, 100, 100,
						100, 0, 29, 14, 14, 29, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "aim sound (Studio Box)",
				generalMidi: false,
				tags: ["harmonics", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 }],
					panDelay: 0,
					reverb: 45,
					reverbfeedback: 77,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 14, 29,
						0, 0, 0,
					],
					unison: "octave",
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 9.5,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "unison",
							envelope: "linear",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},

			{
				name: "BulbBox Church Bell",
				midiProgram: 80,
				tags: ["noise", "bulbbox", "novelty"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["panning", "phaser"],
					phaserMix: 100,
					phaserFreq: 81,
					phaserFeedback: 100,
					phaserStages: 103,
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					unison: "none",
					wave: "white",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: false,
				},
			},
			// { name: "", generalMidi: false, tags:["", "novelty"], settings: {} },
			// { name: "", generalMidi: false, tags:["", "novelty"], settings: {} },
		]),
	},
	{
		name: "Misc Modded Presets",
		/*DRUMS*/ presets: toNameMap([
			// -------------JukeBox 0.0.1--------------
			{
				name: "nes white (UltraBox)",
				midiProgram: 116,
				generalMidi: true,
				isNoise: true,
				tags: ["noise", "retro"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					eqSubFilters1: [],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 0,
					wave: "1-bit white",
					envelopes: [],
				},
			},
			{
				name: "nes ping (UltraBox)",
				midiProgram: 116,
				generalMidi: true,
				isNoise: true,
				tags: ["noise", "retro"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					eqSubFilters1: [],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: 0,
					wave: "1-bit metallic",
					envelopes: [],
				},
			},
			{
				name: "Hollow Retro Riser (MidBox)",
				isNoise: true,
				generalMidi: false,
				tags: ["noise", "retro"],
				settings: {
					type: "noise",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 }],
					eqFilterType: true,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus", "echo", "reverb"],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 0.5,
					reverb: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "hollow",
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Heavy Knock (AbyssBox)",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "drum"],
				settings: {
					type: "noise",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "white",
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "spectrum wind (Slarmoo's Box)",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "ambience"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 1.4142 }],
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					spectrum: [
						29, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 14, 57, 14, 0, 57, 57, 0, 0, 57, 0, 71,
						14, 29, 100, 71, 0, 100, 14, 86,
					],
					unison: "none",
					envelopes: [],
					isDrum: true,
				},
			},
			{
				name: "hi-hat (Slarmoo's Box)",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "hihat"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 4756.83,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 4756.83,
							linearGain: 0.1768,
						},
					],
					eqSubFilters1: [
						{ type: "low-pass", cutoffHz: 16000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 4756.83,
							linearGain: 0.1768,
						},
					],
					eqSubFilters2: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 4756.83,
							linearGain: 0.1768,
						},
					],
					eqSubFilters3: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.1768 },
						{
							type: "high-pass",
							cutoffHz: 4756.83,
							linearGain: 0.1768,
						},
					],
					effects: [],
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					wave: "white",
					unison: "none",
					envelopes: [],
					isDrum: true,
				},
			},
			{
				name: "air hiss (Slarmoo's Box)",
				generalMidi: false,
				isNoise: true,
				tags: ["spectrum", "ambience", "sfx"],
				settings: {
					type: "spectrum",
					volume: 0,
					eqFilter: [{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.25 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
					],
					distortion: 71,
					aliases: false,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -24,
					spectrum: [
						57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 57, 71, 86, 100,
						100, 100, 100, 86, 71, 71, 43,
					],
					unison: "none",
					envelopes: [],
					isDrum: true,
				},
			},
			{
				name: "shaker (Slarmoo's Box)",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "drum"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [
						{ type: "high-pass", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 8 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 6,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 4000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 8 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.25 },
					],
					effects: [
						"transition type",
						"detune",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 30,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 43,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 1,
					reverb: 23,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 96,
					wave: "deep",
					unison: "none",
					envelopes: [
						{
							target: "detune",
							envelope: "tremolo2",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "bitcrusherQuantization",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "note size",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 96,
							inverse: false,
							perEnvelopeSpeed: 0,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
						{
							target: "noteVolume",
							envelope: "flare",
							pitchEnvelopeStart: 0,
							pitchEnvelopeEnd: 12,
							inverse: false,
							perEnvelopeSpeed: 64,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
						},
					],
					isDrum: true,
				},
			},
			{
				name: "White Noise (VoxBox)",
				generalMidi: false,
				isNoise: true,
				tags: ["noise", "retro"],
				settings: {
					type: "noise",
					volume: 0,
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 8,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["panning"],
					pan: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "white",
					envelopes: [],
					isDrum: true,
				},
			},
			{
				name: "Chocolate Harsh (Unbox)",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "distortion"],
				settings: {
					type: "drumset",
					eqFilter: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 4 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 19027.31, linearGain: 4 },
						{ type: "peak", cutoffHz: 11313.71, linearGain: 2 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 3363.59, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 250, linearGain: 0.7071 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.3536 },
					],
					effects: [
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 176.78,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 176.78,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.0884 },
					],
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 1.417,
					reverb: 3,
					drums: [
						{
							filterEnvelope: "twang 2",
							spectrum: [
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 100, 57, 43, 43, 29, 57, 43, 29, 71, 43, 43, 43, 43, 57,
								43, 43, 43, 43, 43, 43, 43, 43, 29, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 1",
							spectrum: [
								0, 0, 0, 0, 0, 71, 57, 43, 43, 43, 57, 57, 43, 29, 57, 43, 43, 43,
								29, 43, 57, 43, 43, 43, 43, 43, 43, 29, 43, 43,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								0, 14, 29, 43, 86, 71, 29, 43, 43, 43, 43, 29, 71, 29, 71, 29, 43,
								43, 43, 43, 57, 43, 43, 57, 43, 43, 43, 57, 57, 57,
							],
						},
						{
							filterEnvelope: "decay 1",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 57, 71, 71,
								71, 71, 71, 71, 71, 71, 57, 57, 57, 57, 43, 43, 43,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								43, 43, 43, 71, 29, 29, 43, 43, 43, 29, 43, 43, 43, 29, 29, 43, 43,
								29, 29, 29, 57, 14, 57, 43, 43, 57, 43, 43, 57, 57,
							],
						},
						{
							filterEnvelope: "twang 2",
							spectrum: [
								29, 43, 43, 43, 43, 29, 29, 43, 29, 29, 43, 29, 14, 29, 43, 29, 43,
								29, 57, 29, 43, 57, 43, 71, 43, 71, 57, 57, 71, 71,
							],
						},
						{
							filterEnvelope: "punch",
							spectrum: [
								43, 29, 29, 43, 29, 29, 29, 57, 29, 29, 29, 57, 43, 43, 29, 29, 57,
								43, 43, 43, 71, 43, 43, 71, 57, 71, 71, 71, 71, 71,
							],
						},
						{
							filterEnvelope: "tremolo2",
							spectrum: [
								57, 57, 57, 43, 57, 57, 43, 43, 57, 43, 43, 43, 71, 57, 43, 57, 86,
								71, 57, 86, 71, 57, 86, 100, 71, 86, 86, 86, 86, 86,
							],
						},
						{
							filterEnvelope: "punch",
							spectrum: [
								0, 0, 14, 14, 14, 14, 29, 29, 29, 43, 43, 43, 57, 57, 71, 71, 86,
								86, 100, 100, 86, 57, 57, 57, 71, 71, 100, 100, 100, 100,
							],
						},
						{
							filterEnvelope: "decay 2",
							spectrum: [
								14, 14, 14, 14, 29, 14, 14, 29, 14, 43, 14, 43, 57, 86, 57, 57, 100,
								57, 43, 43, 57, 100, 57, 43, 29, 14, 0, 0, 0, 0,
							],
						},
					],
					envelopes: [
						{ target: "noteFilterFreq", envelope: "linear 1", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "twang 2",
							index: 2,
						},
					],
				},
			},
			{
				name: "Chocolate Corrupted (Unbox)",
				generalMidi: false,
				isNoise: true,
				tags: ["drumset", "novelty"],
				settings: {
					type: "drumset",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher", "chorus"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 86,
					panDelay: 10,
					chorus: 14,
					drums: [
						{
							filterEnvelope: "tripolo6",
							spectrum: [
								57, 29, 57, 0, 14, 100, 57, 57, 71, 29, 57, 43, 0, 57, 100, 0, 0, 0,
								43, 71, 0, 57, 0, 86, 0, 0, 0, 29, 14, 14,
							],
						},
						{
							filterEnvelope: "tremolo3",
							spectrum: [
								0, 43, 100, 0, 86, 14, 0, 29, 43, 29, 14, 0, 0, 0, 0, 0, 0, 0, 0, 0,
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "tripolo1",
							spectrum: [
								0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 29, 14, 29, 0,
								29, 0, 14, 14, 100, 29, 86, 71, 14,
							],
						},
						{
							filterEnvelope: "swell 2",
							spectrum: [
								71, 0, 0, 14, 100, 0, 86, 0, 29, 14, 43, 71, 43, 71, 86, 86, 14, 0,
								86, 0, 0, 86, 14, 71, 0, 0, 29, 14, 71, 0,
							],
						},
						{
							filterEnvelope: "tremolo4",
							spectrum: [
								43, 0, 0, 57, 86, 71, 71, 29, 57, 57, 0, 71, 100, 57, 29, 0, 14, 14,
								29, 86, 0, 14, 43, 29, 100, 100, 0, 86, 14, 86,
							],
						},
						{
							filterEnvelope: "linear 1",
							spectrum: [
								100, 14, 0, 14, 0, 43, 57, 29, 14, 43, 71, 0, 57, 57, 71, 14, 71,
								14, 57, 43, 43, 29, 29, 86, 14, 100, 43, 86, 14, 29,
							],
						},
						{
							filterEnvelope: "twang 2",
							spectrum: [
								100, 29, 0, 0, 14, 0, 100, 0, 0, 29, 14, 14, 0, 14, 0, 29, 0, 29,
								57, 43, 0, 0, 86, 0, 86, 14, 100, 14, 0, 0,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 0, 0, 14, 0, 29, 57, 0, 0, 0, 0, 71, 29, 0, 14, 43, 0, 29, 14,
								43, 100, 29, 14, 14, 0, 57, 43, 0, 0,
							],
						},
						{
							filterEnvelope: "blip 2",
							spectrum: [
								0, 71, 14, 0, 43, 86, 0, 29, 43, 14, 57, 43, 43, 14, 0, 100, 14, 0,
								86, 0, 86, 71, 14, 0, 0, 29, 0, 29, 0, 14,
							],
						},
						{
							filterEnvelope: "twang 2",
							spectrum: [
								14, 0, 100, 14, 0, 0, 71, 29, 0, 0, 0, 100, 0, 0, 100, 14, 0, 0, 14,
								0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0,
							],
						},
						{
							filterEnvelope: "twang 3",
							spectrum: [
								86, 14, 0, 0, 0, 0, 100, 14, 14, 0, 29, 71, 14, 29, 14, 0, 0, 0, 57,
								0, 0, 0, 0, 14, 100, 0, 100, 43, 0, 14,
							],
						},
						{
							filterEnvelope: "flare 1",
							spectrum: [
								0, 0, 29, 57, 0, 0, 0, 86, 29, 0, 14, 0, 100, 0, 43, 14, 43, 0, 14,
								0, 14, 0, 86, 71, 0, 0, 14, 43, 71, 0,
							],
						},
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
			// { name: "", generalMidi: false, tags:[""], settings: {} },
		]),
	},
	{
		name: "UnBox Synth Lead",
		presets: toNameMap([
			{
				name: "Filtered Sawtooth Lead",
				midiProgram: 82,
				tags: ["chip", "chipwave", "unbox", "lead"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 1,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 29,
					aliases: true,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "decay 3", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "decay 3",
							index: 1,
						},
					],
				},
			},
			{
				name: "Plucky Lead",
				midiProgram: 83,
				tags: ["fm", "fm4op", "unbox", "lead"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 1 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 13, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Shimmer Lead",
				midiProgram: 84,
				tags: ["fm", "fm4op", "unbox", "lead"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					panDelay: 10,
					chorus: 86,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Distorted Lead",
				midiProgram: 81,
				tags: ["fm", "fm4op", "unbox", "lead"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 }],
				},
			},
			{
				name: "Soft Lead",
				midiProgram: 84,
				tags: ["chip", "customchip", "unbox", "lead"],
				settings: {
					type: "custom chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.5,
						},
					],
					effects: [
						"chord type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 7,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 6,
					vibratoType: 0,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": 24,
						"1": 24,
						"2": 24,
						"3": 24,
						"4": 24,
						"5": 24,
						"6": 24,
						"7": 24,
						"8": 24,
						"9": 23,
						"10": 22,
						"11": 22,
						"12": 21,
						"13": 20,
						"14": 19,
						"15": 18,
						"16": 17,
						"17": 17,
						"18": 16,
						"19": 14,
						"20": 12,
						"21": 11,
						"22": 8,
						"23": 6,
						"24": 3,
						"25": -2,
						"26": -6,
						"27": -11,
						"28": -19,
						"29": -22,
						"30": -24,
						"31": -24,
						"32": -24,
						"33": -22,
						"34": -13,
						"35": -5,
						"36": -1,
						"37": 4,
						"38": 6,
						"39": 10,
						"40": 12,
						"41": 14,
						"42": 16,
						"43": 16,
						"44": 18,
						"45": 18,
						"46": 20,
						"47": 21,
						"48": 21,
						"49": 22,
						"50": 22,
						"51": 23,
						"52": 24,
						"53": 24,
						"54": 24,
						"55": 24,
						"56": 24,
						"57": 24,
						"58": 24,
						"59": 24,
						"60": 24,
						"61": 24,
						"62": 24,
						"63": 24,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [],
				},
			},
			{
				name: "Pulse Lead",
				generalMidi: false,
				tags: ["pwm", "unbox", "lead"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "vibrato", "bitcrusher", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 24,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 12,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "PWM Lead*",
				generalMidi: false,
				tags: ["pwm", "unbox", "lead"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 22,
					discreteEnvelope: true,
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 50,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 24,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 14711.41, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 14711.41, linearGain: 1 }],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "noteVolume", envelope: "note size" },
						{
							target: "pulseWidth",
							envelope: "flare 3",
						},
					],
				},
			},
			{
				name: "Smooth Lead",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "lead"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					effects: ["transition type", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 2,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←(4 5)←6",
					feedbackType: "Custom",
					feedbackAmplitude: 6,
					customFeedback: { mods: [[1], [4], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 1, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
		]),
	},
];
